<template>
    <div
        :class="classArray"
        :style="styleObject"
    >
        <div class="button__text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AppButton',
        props: [
            'type',
            'align'
        ],
        computed: {
            classArray () {
                return [
                    'button',
                    `button--type_${this.type}`
                ];
            },

            styleObject() {
                return {
                    'margin': this.align === 'center' ? '0 auto' : '0'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button {
        display: flex;
        align-items: center;
        max-width: 320px;
        height: 44px;
        color: white;
        cursor: pointer;
        border-radius: 3px;

        &:hover {
            opacity: 0.7;
        }

        &__text {
            width: 100%;
            font-size: 1.5em;
            text-align: center;
        }

        &--type {
            &_default {
                border: solid 2px gray;
                color: #333;
            }

            &_primary {
                background-color: #1867c0;
            }

            &_success {
                background-color: #009688;
            }
        }
    }
</style>